module.exports = __webpack_public_path__ + "static/media/roomafricaA.377dca58.JPG";